<template>
  <form @submit.prevent="addItemToOrder">
    <div class="row">
      <div class="mb-3 col-sm-4">
        <label>Product</label>
        <multiselect v-model="order.product" :options="products" placeholder="Select one" :searchable="true" label="productName" track-by="productName"></multiselect>
        <p
            v-for="error of v$.order.product.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="mb-3 col-sm-2">
        <label>Quantity</label>
        <input
            v-model="order.quantity"
            type="number"
            class="form-control"
            :class="{
                        'is-invalid': v$.order.quantity.$error,
                  }"
        />
        <p
            v-for="error of v$.order.quantity.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="mb-3 col-sm-3 form-group align-self-end">
        <b-button variant="primary" size="sm" disabled v-if="ordersLoading">
          <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          Loading
        </b-button>
        <b-button variant="primary" size="sm" class="text-white" type="submit" v-else>
          Add to order
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from 'vue-multiselect'
import {mapGetters} from "vuex";
import {permissions} from "@/router/permissions";

export default {
name: "customer-add-product-component",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    Multiselect
  },
  data(){
    return{
      order:{
        product: "",
        warehouse: "",
        quantity: ""
      },
      order_add_warehouse_permission: permissions.order_add_warehouse_permission,
    }
  },
  props: {
    products: {type: Array},
    orderId: {type: String}
  },
  validations() {
    return{
      order:{
        product: {required},
        quantity: {required}
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading'
    }),
  },
  methods: {
    async addItemToOrder() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        order: this.orderId,
        itemId: this.order.product.publicId,
        itemCount: parseInt(this.order.quantity),
        warehouseId: ''
      }
      this.$emit('addItemToOrder', data)
      this.v$.$touch();

    }
  }
}
</script>

<style scoped>

</style>
